
import Env from '../base/env.js';
import Channels from '../base/channels.js';
import lozad from 'lozad'
import Launcher from '../view/launcher'
import MainnavTouch from '../ui/MainnavTouch'
import UISwitcher from '../ui/UISwitcher'
import BtnShadow from '../fx/BtnShadow'
import gsap from 'gsap'
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { ScrollSmoother } from "../vendor/gsap-bonus-umd/ScrollSmoother";
import { ScrollToPlugin } from '../vendor/gsap-bonus-umd/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger,ScrollSmoother,ScrollToPlugin);
import CanvasAnim from '../components/Canvas.js';
import Storytelling from '../components/Storytelling'
import lottie from 'lottie-web'


class UI
{
    constructor()
    {
      if(typeof history.scrollRestoration != 'undefined') {
          history.scrollRestoration = 'manual';
      }
      //? Vars
      this.VARS = {
        smooth:{
          progress:0,
          scrolltop:0
        }
      }
      //? Fns
      this.launcher = new Launcher()
      Env.framework.mainnav = new MainnavTouch()
      this.uiSwitch =  new UISwitcher()
      this.detectAppHeight()
      this.resetEnv();
      setTimeout(() => {
        this.smoothScroll()
      }, 100);
      new CanvasAnim()
      // new BtnShadow(document.querySelector('.btn-explore'))
      new BtnShadow(document.querySelector('.btn-contact'))
      new BtnShadow(document.querySelector('.btn-menu'))
      this.storytelling = new Storytelling()
      this.updateDom()
      this.events()
    }

    appHeight()
    {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }

    detectAppHeight()
    {
      this.appHeight()
      Channels.on('window::smartresize',this.appHeight)
    }

    events()
    {
      document.querySelector('.btn-explore').addEventListener('click',()=>{
        console.log('click');
        const viewport = Env.framework.toolbox.getViewport()
        const goToY = viewport.height * 2
        gsap.to(
          window,
          {
            scrollTo:{y:goToY},
            ease:'quint.inOut',
            duration:2
        })
      })
    }


    lazy()
    {
      const observer = lozad(); // lazy loads elements with default selector as '.lozad'
      observer.observe();
    }

    updateDom()
    {
      const $animationContainer = document.querySelector('.fxArrow .animation')
      const anim = lottie.loadAnimation({
        container: $animationContainer,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: config.pathAssets+'/animation/lf30_idatbjcb.json'
      });
      document.querySelector('.btn-explore').addEventListener('mouseenter',()=>{
        anim.setSpeed(1)
        anim.setDirection(1)
        anim.play()
      })
      document.querySelector('.btn-explore').addEventListener('mouseleave',()=>{
        anim.setSpeed(2)
        anim.setDirection(-1)
        anim.play()
      })
    }

    resetEnv()
    {
      Channels.on('statechange::before',function()
      {

      })
      Channels.on('statechange::ready',(current,old,container)=>
      {
          Env.$html.classList.remove('ui--isWhite')
          Env.$html.classList.remove('logo-minimized')
          // Env.$html.classList.remove('skin--isDark')
          // Env.$mainNav.classList.remove('is--active');
          // Env.$html.classList.remove('mainnav--isOpened')
        })
    }

    smoothScroll()
    {
      Env.smoothInstance = ScrollSmoother.create({
        wrapper:document.querySelector('.jsSmoothWrapper'),
        content:document.querySelector('.jsSmoothContent'),
        smooth: .6,
        effects: true,
        smoothTouch: 0.1,
        ease:'quint.out',
        onUpdate:(e)=>{
          this.VARS.smooth.direction = e.scrollTrigger.direction
          this.VARS.smooth.scrolltop = e.scrollTop()
          this.VARS.smooth.progress = e.progress
        }
      });
    }

    smoothScrollRefresh()
    {
      setTimeout(() => {
        Env.smoothInstance.scrollTrigger.refresh()
      }, 500);
    }


}

export default UI;
